import { FileCreationMetadata } from 'src/types/fileUpload';

/**
 * A file whose metadata settled with no fields never parsed — the default
 * options failed and the preview was never used to fix them. Creating a
 * project aborts for such a file, so actions gate on this up front.
 */
export const hasUnparsedCsv = (
  selectedFiles: File[],
  fileMetadata: Record<number, FileCreationMetadata>
) =>
  selectedFiles.some(
    (_, index) => fileMetadata[index] && !fileMetadata[index].fields.length
  );
